import PropTypes from 'prop-types';
import React, {
    useContext,
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
    POL_THEME,
    ThemeContext,
} from '../../constants/theme';
import { getPublicationPage } from '../../utils/routes';

import styles from './ViewBulletinSection.scss';

const ViewBulletinSection = ({
    publication, slug,
}) => {
    const history = useNavigate();
    const themeContext = useContext(ThemeContext);

    const onClickHandler = (event) => {
        event.preventDefault();
        history(getPublicationPage(slug, publication.fileUrl));
    };

    return (
        <div className={styles.publicationContainer}>
            <a
                href={publication.fileUrl}
                rel="noreferrer"
                onClick={onClickHandler}
                aria-label={`View ${themeContext === POL_THEME ? 'Bulletin' : 'Newsletter'}`}
            >
                <img
                    alt="Latest Publication"
                    src={publication.highResolutionThumbnailUrl}
                    width="240"
                    height="310"
                />
            </a>
        </div>
    );
};

ViewBulletinSection.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
    }),
    publication: PropTypes.shape({
        contentDir: PropTypes.string,
        contentType: PropTypes.string,
        customerNumber: PropTypes.string,
        fileUrl: PropTypes.string,
        name: PropTypes.string,
        pid: PropTypes.string,
        publishDate: PropTypes.string,
        largeThumbnailUrl: PropTypes.string,
        highResolutionThumbnailUrl: PropTypes.string,
        smallThumbnailUrl: PropTypes.string,
        extraLargeThumbnailUrl: PropTypes.string,
        type: PropTypes.string,
    }).isRequired,
    slug: PropTypes.string,
};

ViewBulletinSection.defaultProps = {
    classes: {
        root: null,
    },
    slug: '',
};

export default ViewBulletinSection;
